import * as React from 'react'

import useFetchDefaultShifts from 'modules/shift_management/components/ShiftManagement/MainPage/useFetchDefaultShifts'
import DefaultShiftWithParamsForm from 'modules/shift_management/lib/forms/DefaultShiftWithParamsForm'
import type DefaultShift from 'modules/shift_management/store/internal/models/DefaultShift'

const useDefaultShiftForms = () => {
  const visibleDefaultShifts = useFetchDefaultShifts({})

  const initializeForms = () => {
    return visibleDefaultShifts.defaultShifts.active.map((defaultShift: DefaultShift) => {
      const {
        id,
        title,
        startAt,
        endAt,
        overnightShift,
        color,
        locationId,
        workAreaId,
        notes,
        extraHours,
      } = defaultShift

      return new DefaultShiftWithParamsForm({
        id,
        title,
        start_at: startAt,
        end_at: endAt,
        extra_hours: extraHours,
        color,
        overnight_shift: overnightShift,
        location_id: locationId,
        work_area_id: workAreaId,
        notes,
      })
    })
  }

  const [forms, setForms] = React.useState<DefaultShiftWithParamsForm[]>(initializeForms())

  const onToggleShift = (id: string) => {
    const form = forms.find((form) => form.get('id').value === id)

    if (!form) throw 'Could not find form'

    form.get('is_selected').set(!form.get('is_selected').value)
  }

  return {
    forms,
    setForms,
    onToggleShift,
  }
}

export default useDefaultShiftForms
